import * as React from "react";
import { Button, Divider, Form, Grid, Input, Label } from 'semantic-ui-react';
import { authentication } from "../../../../../authentication";
import { MultiScriptExecutionRequest, ViewConfigurationScripts } from "../../../../../generated/api";
import { backend } from "../../../../../xconvert-backend";
import { ConfigContext } from "../../../context/ConfigContext";
import TabMenuMultiScript from "./TabMenuMultiScript";
import { LogView } from "../../logView/LogView";
import AceEditor from 'react-ace';

import 'brace/mode/groovy'
import 'brace/ext/searchbox'


export interface ScriptExecutionState {
    isConverting: boolean
    validJson: boolean
    scriptExeToId: string
    xRequestId: string
}

export class MultiScriptExecution extends React.Component<any, ScriptExecutionState> {

    static contextType = ConfigContext
    context!: React.ContextType<typeof ConfigContext>;

    constructor(props) {
        super(props)
        console.log("loading onViewXxxScript Execution")

        this.state = {
            isConverting: false,
            validJson: true,
            scriptExeToId: "",
            xRequestId: null,
        }
    }

    async doConvert() {

        this.setState({ isConverting: true })

        let auth = backend.withTokenAuthHeader(authentication.token)

        // creating request
        let scriptRequest = {} as MultiScriptExecutionRequest
        scriptRequest.transportOrderId = this.context.multiScriptExeToId
        if (this.context.multiScriptExeToInput != null && this.context.multiScriptExeToInput != "") {

            scriptRequest.transportOrder = JSON.parse(this.context.multiScriptExeToInput)
        }
        scriptRequest.companyId = this.context.companyId

        let viewConfigurationScripts = {} as ViewConfigurationScripts
        viewConfigurationScripts.onViewFreight = this.context.multiScriptExeFreightScript
        viewConfigurationScripts.onViewStopLocation = this.context.multiScriptExeStopScript
        viewConfigurationScripts.onViewTransport = this.context.multiScriptExeTransportScript
        viewConfigurationScripts.onViewTransportOrder = this.context.multiScriptExeToScript

        scriptRequest.viewConfigurationScripts = viewConfigurationScripts

        // call script-endpoint
        let response = await this.multiScriptExecutionWithXRequestId(scriptRequest, auth)

        let toOutputAsJson = JSON.stringify(response, null, 4)
        this.context.setMultiScriptExeToOutput(toOutputAsJson)
        this.setState({ isConverting: false })
    }

    async multiScriptExecutionWithXRequestId(request, auth) {
        // since using the auto-generated api is only returning the TransportOrder without the xRequestId
        // I'm calling the endpoint manually to be able to extrackt the xRequestId for the logs

        let response = await fetch('/api/internal/multiScriptExecution', {
            method: 'POST',
            headers: {
                "Authorization": auth.headers.Authorization,
                "Content-Type": "application/json; charset=utf-8"
            },
            body: JSON.stringify(request)
        })

        let resp = await response.json()

        this.setState({ xRequestId: response.headers.get("x-request-id") })

        return resp
    }
    async handleLoadTransportOrder() {
        let auth = backend.withTokenAuthHeader(authentication.token)
        let transportOrder = await backend.transportOrderApi.fetchTransportOrderById(this.context.multiScriptExeToId, auth)

        let toAsJson = JSON.stringify(transportOrder, null, 4)
        this.handleTransportOrderChange(toAsJson)
    }

    handleTransportOrderChange(value) {
        let valid = null
        try {
            JSON.parse(value)
            valid = true
        } catch (e) {
            valid = false
        }

        this.context.setMultiScriptExeToInput(value)
        this.context.setMultiScriptExeValid(valid)
        this.setState({ validJson: valid })

    }

    setScriptExeToId(value) {
        this.setState({ scriptExeToId: value })
        this.context.setMultiScriptExeToId(value)
    }

    componentDidMount() {
        this.setState({ scriptExeToId: this.context.multiScriptExeToId })
    }

    render() {

        return <Form>

            <Input
                style={{ width: 220 }}
                placeholder='TransportOrderId'
                value={this.state.scriptExeToId}
                onChange={(evt) => this.setScriptExeToId(evt.target.value?.trim())} />
            <Button onClick={() => this.handleLoadTransportOrder()}>load TransportOrder</Button>
            <br /><br />
            <Button onClick={(evt) => this.doConvert()} loading={this.state.isConverting}>Execute</Button>
            <Divider hidden />

            <Grid padded="horizontally" stackable columns='equal' centered>
                <Grid.Row>
                    <Grid.Column width={4}>
                        <TabMenuMultiScript context={this.context}/>
                    </Grid.Column>
                    <Grid.Column>
                        <Label>
                            TransportOrder
                        </Label>
                        <AceEditor
                            theme="monokai"
                            mode="json"
                            value={this.context.multiScriptExeToInput}
                            placeholder='TransportOrder to be modified by script'
                            width='100%'
                            height="800px"
                            onChange={(e) => this.handleTransportOrderChange(e)}
                            readOnly={false}
                        />
                        {!this.state.validJson ? <Label size={'huge'} color='red' pointing>INVALID JSON</Label> : null}
                    </Grid.Column>
                    <Grid.Column>
                        <Label>
                            TransportOrder nach Script
                        </Label>
                        <AceEditor
                            theme="monokai"
                            mode="json"
                            value={this.context.multiScriptExeToOutput}
                            placeholder='TransportOrder nach Script'
                            width='100%'
                            height="800px"
                            readOnly={true}
                        />
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                    <Grid.Column>
                        <h4>Logs:</h4>
                        <LogView
                            query={this.state.xRequestId}
                            origin={"multiScript"}
                            initialTimespan={null}
                            responseLogs={null}
                        />
                    </Grid.Column>
                </Grid.Row>
            </Grid>
        </Form>
    }

}